import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddTestComp from "./Component/AddTestComp"


const AddTest =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddTestComp />
        </div>
        <Footer />
        </>
    )
}

export default AddTest